import React from 'react'
import { getStartEndDate } from '../../../../../helpers/getStartEndDate';
import { getStartEndDateBp } from '../../../../../helpers/getStartEndDateBp';
import { numberFormat } from '../../../../../helpers/numberFormat';

const FiveInfoProgramCorporate = (props) => {

    // console.log(props)

    return (
        <>
            <div className='row' style={{ marginLeft: '5px', marginTop: props.size.width < 500 ? '10%' : '3%' }}>
                <h5 style={{ color: '#26D07C', marginBottom: '3%', fontSize: '16px', fontWeight: '700' }}>Informasi Program dan Data Peserta</h5>
                {
                    props.bpSelected.map((bp, j) =>
                        <>
                            <div className='col-lg-12' style={{ marginBottom: '3%' }}>
                                <div className='row mb-3'>
                                    <div className='col-lg-6'>
                                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Program Bundling</label>
                                        <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{bp.name}</p>
                                    </div>
                                    <div className='col-lg-6'>
                                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Harga</label>
                                        <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>Rp. {numberFormat(bp.price)}</p>
                                    </div>
                                </div>
                                {
                                    bp.BundlingProgramItems.map((bpi, j) =>
                                        <>
                                            <h4>Program {j + 1}</h4>
                                            <div className='row mb-4'>
                                                <div className='col-lg-6'>
                                                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama Program</label>
                                                    <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{bpi.Program.name}</p>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Jadwal Program</label>
                                                    <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{getStartEndDateBp(props.bpScheduleSelected, bpi.Program.id)}</p>
                                                </div>
                                            </div>
                                            {/* <h4>Daftar Peserta</h4>
                                            <div className="card" style={{ marginBottom: props.size.width < 500 ? '10%' : '6%' }}>
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table">
                                                            <thead>
                                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                    <th className='text-center'>Nama</th>
                                                                    <th className='text-center'>Salutation</th>
                                                                    <th className='text-center'>Email</th>
                                                                    <th className='text-center'>Nomor Handphone</th>
                                                                    <th className='text-center'>Pekerjaan</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    props.bpParticipants.map((participant, j) =>
                                                                        bpi.id === participant.bpiId ?
                                                                            <>
                                                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                                    <td>{participant.namaDepanPeserta} {participant.namaBelakangPeserta}</td>
                                                                                    <td>{participant.salutationPeserta}</td>
                                                                                    <td>{participant.emailPeserta}</td>
                                                                                    <td>{participant.hpPeserta}</td>
                                                                                    <td>{participant.jabatanPeserta}</td>
                                                                                </tr>
                                                                                <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                                </tr>
                                                                            </>
                                                                            :
                                                                            ''
                                                                    )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </>
                                    )
                                }
                                <h4>Daftar Peserta</h4>
                                <div className="card" style={{ marginBottom: props.size.width < 500 ? '10%' : '6%' }}>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                        <th className='text-center'>Nama</th>
                                                        <th className='text-center'>Salutation</th>
                                                        <th className='text-center'>Email</th>
                                                        <th className='text-center'>Nomor Handphone</th>
                                                        <th className='text-center'>Pekerjaan</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        props.bpParticipants.map((participant, j) =>
                                                            bp.id === participant.bpId ?
                                                                <>
                                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                        <td>{participant.namaDepanPeserta} {participant.namaBelakangPeserta}</td>
                                                                        <td>{participant.salutationPeserta}</td>
                                                                        <td>{participant.emailPeserta}</td>
                                                                        <td>{participant.hpPeserta}</td>
                                                                        <td>{participant.jabatanPeserta}</td>
                                                                    </tr>
                                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                    </tr>
                                                                </>
                                                                :
                                                                ''
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <hr className='mt-0'></hr>
                            </div>
                        </>
                    )
                }

                {
                    props.programSelected.map((program, j) =>
                        <>
                            <div className='col-lg-12' style={{ marginBottom: '3%' }}>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama Program</label>
                                        <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{program.name}</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Jadwal Program</label>
                                        <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{getStartEndDate(props.scheduleSelected, program.id)}</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Harga</label>
                                        <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>Rp. {numberFormat(program?.Pricebooks[0].price)}</p>
                                    </div>
                                </div>
                                <h4>Daftar Peserta</h4>
                                <div className="card" style={{ marginBottom: props.size.width < 500 ? '10%' : '6%' }}>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                        <th className='text-center'>Nama</th>
                                                        <th className='text-center'>Salutation</th>
                                                        <th className='text-center'>Email</th>
                                                        <th className='text-center'>Nomor Handphone</th>
                                                        <th className='text-center'>Pekerjaan</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        props.participants.map((participant, j) =>
                                                            program.id === participant.programId ?
                                                                <>
                                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                        <td>{participant.namaDepanPeserta} {participant.namaBelakangPeserta}</td>
                                                                        <td>{participant.salutationPeserta}</td>
                                                                        <td>{participant.emailPeserta}</td>
                                                                        <td>{participant.hpPeserta}</td>
                                                                        <td>{participant.jabatanPeserta}</td>
                                                                    </tr>
                                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                                    </tr>
                                                                </>
                                                                :
                                                                ''
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <hr className='mt-0'></hr>
                            </div>
                        </>
                    )
                }
            </div>
        </>
    )
}

export default FiveInfoProgramCorporate
